<template>
    <div>
        <v-app-bar :clipped-left="toolbar.clippedLeft" app color="primary" dark>
            <v-btn
                text
                icon
                @click="refreshDefectNotices()"
                class="ml-3"
                v-if="hasSelectedGarage()"
            >
                <v-icon>mdi-refresh</v-icon>
            </v-btn>
            <v-btn
                text
                icon
                @click="showSearchBar()"
                class="ml-3"
                v-if="!showSearch && hasSelectedGarage()"
            >
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="accent"
                class="mr-5"
                @click="nhvasReport()"
                v-if="hasSelectedGarage()"
            >NHVAS Report</v-btn>
            <v-flex md3>
                <garage-select></garage-select>
            </v-flex>
        </v-app-bar>

        <defect-notices
            ref="defectNotices"
            @closesearch="showSearch = false"
            v-if="hasSelectedGarage()"
        ></defect-notices>
        <v-alert v-else type="warning" class="ma-5">You have not selected a Garage Location</v-alert>
        <v-dialog persistent v-model="showNhvasForm" max-width="700px">
            <nhvas-form ref="nhvasForm">
                <template v-slot:header>
                    <v-spacer></v-spacer>
                </template>
                <template v-slot:actions>
                    <v-btn @click="showNhvasForm = false">Cancel</v-btn>
                </template>
            </nhvas-form>
        </v-dialog>
    </div>
</template>

<script>
import DefectNotices from '@/components/DefectNotices/DefectNotices.vue';
import NhvasForm from '@/components/DefectNotices/NhvasForm.vue';
import GarageSelect from '@/components/GarageLocations/GarageSelect.vue';
import GarageLocationsClient from '@/components/GarageLocations/GarageLocationsClient.vue';
import CONFIG from '@/config';

export default {
  components: { DefectNotices, GarageSelect, NhvasForm },
  mixins: [GarageLocationsClient],
  data: () => ({
    drawer: {
      open: true,
      clipped: false,
      mini: true
    },
    toolbar: {
      fixed: true,
      clippedLeft: false
    },
    showNhvasForm: false,
    showSearch: false,
    refreshTimer: null
  }),
  async mounted() {
    await this.getGarageSelections();
    await this.loadUserGarages();

    // Refresh the page every minute (configurable) to capture any data that has changed from InShop/OnRoad
    const minutes = CONFIG.timers.defectsRefreshMinutes;
    this.refreshTimer = setInterval(() => {
      this.refreshDefectNotices();
    }, 1000 * 60 * minutes);
  },

  beforeDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  },
  methods: {
    nhvasReport() {
      this.showNhvasForm = true;
      this.$nextTick(() => this.$refs.nhvasForm.init());
    },
    showSearchBar() {
      this.showSearch = true;
      this.$refs.defectNotices.showSearchBar();
    },
    refreshDefectNotices() {
      this.$refs.defectNotices.refresh();
    }
  }
};
</script>

<style lang="scss" scoped></style>
